import { Helmet } from 'react-helmet-async';
import { useState } from 'react';
import { useFormik } from 'formik';
import { useNavigate } from 'react-router-dom';
import { Alert, Button, Card, CardContent, Grid, TextField } from '@mui/material';

import { useCreateQuestionnaireMutation } from '../../slices/apis/questionnaireMgmtApi';

export default function QuestionnaireNew() {
	const navigate = useNavigate();
	const [createQuestionnaire, { isLoading }] = useCreateQuestionnaireMutation();
	const [error, setError] = useState<string | null>(null);

	const formik = useFormik({
		initialValues: {
			name: '',
			description: '',
		},
		validate: (values) => {
			const errors: { name?: string } = {};

			if (!values.name.trim()) {
				errors.name = 'Name is required';
			}

			return errors;
		},
		onSubmit: async (values) => {
			setError(null);

			try {
				const result = await createQuestionnaire({
					name: values.name,
					description: values.description || null,
				}).unwrap();
				navigate(`/dashboard/admin/questionnaires/${result.id}/edit`);
			} catch {
				setError('Failed to save questionnaire. Please try again.');
			}
		},
	});

	return (
		<>
			<Helmet>
				<title>New Questionnaire — {process.env.REACT_APP_ORG}</title>
			</Helmet>
			<Grid container justifyContent="start">
				<Grid size={{ md: 6 }}>
					<Card sx={{ m: 2 }}>
						<CardContent>
							<form onSubmit={formik.handleSubmit}>
								<Grid container spacing={2}>
									{error && (
										<Grid size={{ md: 12 }}>
											<Alert severity="error">{error}</Alert>
										</Grid>
									)}
									<Grid size={{ md: 12 }}>
										<TextField
											id="name"
											name="name"
											label="Name"
											required
											fullWidth
											margin="dense"
											variant="standard"
											value={formik.values.name}
											onChange={formik.handleChange}
											onBlur={formik.handleBlur}
											error={formik.touched.name && Boolean(formik.errors.name)}
											helperText={formik.touched.name && formik.errors.name}
										/>
									</Grid>
									<Grid size={{ md: 12 }}>
										<TextField
											id="description"
											name="description"
											label="Description"
											fullWidth
											multiline
											margin="dense"
											variant="standard"
											value={formik.values.description}
											onChange={formik.handleChange}
										/>
									</Grid>
									<Grid size={{ md: 4 }}>
										<Grid container justifyContent="start" spacing={4}>
											<Grid size={{ md: 6 }}>
												<Button loading={isLoading} variant="outlined" color="primary" type="submit">
													<span>Save</span>
												</Button>
											</Grid>
											<Grid size={{ md: 6 }}>
												<Button
													color="error"
													variant="outlined"
													onClick={() => navigate('/dashboard/admin/questionnaires')}
												>
													Cancel
												</Button>
											</Grid>
										</Grid>
									</Grid>
								</Grid>
							</form>
						</CardContent>
					</Card>
				</Grid>
			</Grid>
		</>
	);
}
